import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import { gotAdressesByCompany, loadingAddresses } from "../actions/addresses";
import { message } from "antd";

export const getAddressesByCompany = () => async (dispatch) => {
	dispatch(loadingAddresses());
	try {
		const { data } = await client.get("/Voting/addresses", {
			headers: authHeader(),
		});
		dispatch(gotAdressesByCompany(data));
	} catch (e) {
		console.error(e);
		message.error("Не получилось загрузить адреса, попробуйте позже");
	}
};
